import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import * as reportActions from "./report.actions";
import { IReportInfo, IResponse } from "../../models/admin";

export interface IReportState {
    Orders: IReportInfo[];
}

export const initialState: IReportState = {
    Orders: []
}

export const reportReducer = createReducer<IReportState>(
    initialState,
    on(reportActions.FetchGSTOrdersSuccessAction, (state: IReportState, props: { response: IResponse<IReportInfo[]> }) => {
        return {
            ...state,
            Orders: props.response.Value
        }
    })
);

// Selector for GST Orders
export const selectReportState = createFeatureSelector<IReportState>('report');

export const selectGSTOrders = createSelector(
    selectReportState,
    (state: IReportState) => state.Orders
);
